import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';

export function useGetPaymentStatusTranslation(status: string) {
  const { t } = useTranslation(TranslationsKeys.DEGREE_POOCESSES_MAIN);

  switch (status) {
    case 'paid':
      return t(`titulationPayment.paymentStatuses.paid`);
    default:
      return t(`titulationPayment.paymentStatuses.pending`);
  }
}
